/* ModalPhoto1.js */
/* @auhtor: anghello */

import React, { useCallback } from 'react';
import { Modal, ModalBody, Row, Col, Button } from 'reactstrap';
import PSO from '../../services/PSO';
import Strings from '../../translations/Translations';
import { useAuth } from '../../context/auth/AuthContext';
import { toast } from 'react-toastify';
import { IoArrowBack, IoArrowForward } from 'react-icons/io5';
import { FaRegTrashCan, FaDownload } from 'react-icons/fa6';

const IMAGE_SRC = process.env.REACT_APP_PZ_IMAGE_SRC;
const VIDEO_SRC = process.env.REACT_APP_PZ_VIDEO_SRC;
// const POPFANS_URL = process.env.REACT_APP_POPFANS_APP_WEB;
const REMIX_URL = process.env.REACT_APP_REMIX_APP_WEB;

const PZ_VIDEO_DOWNLOAD_URL = process.env.REACT_APP_PZ_VIDEO_DOWNLOAD_URL;
const PZ_IMAGE_DOWNLOAD_LOW_QUALITY_URL = process.env.REACT_APP_PZ_IMAGE_DOWNLOAD_LOW_QUALITY_URL;
const PZ_IMAGE_DOWNLOAD_URL = process.env.REACT_APP_PZ_IMAGE_DOWNLOAD_URL;

export default function ModalPhoto1({ open, setOpen, photo, remixPars, refresh, showNext = false, showPrevious = false, next, previous }) {
  const toggle = useCallback(() => setOpen(!open), [open, setOpen]);
  const { authenticated, toggleLoading } = useAuth();

  const disapproveElement = useCallback(async (eid, etype) => {
    if (eid && etype && remixPars && remixPars.rid) {
      toggleLoading(true);
      try {
        const response = await PSO.disapproveElementInRemix({
          un: authenticated.un,
          al: authenticated.al,
          rid: remixPars.rid,
          eid,
          etype
        });

        if (response.result === 'success') {
          if (refresh) { refresh(); }
        } else {
          const message = (response && response.error) ? response.error : Strings('error_on_request');
          toast.error(message);
        }
        toggleLoading(false);
      } catch (err) {
        toast.error(Strings('general_error'));
        toggleLoading(false);
      }
      toggle();
    }
  }, [authenticated, remixPars, toggleLoading, refresh, toggle]);

  const approveElement = useCallback(async (eid, etype) => {
    if (eid && etype && remixPars && remixPars.rid) {
      toggleLoading(true);
      try {
        const response = await PSO.approveElementInRemix({
          un: authenticated.un,
          al: authenticated.al,
          rid: remixPars.rid,
          eid,
          etype
        });

        if (response.result === 'success') {
          if (refresh) { refresh(); }
        } else {
          const message = (response && response.error) ? response.error : Strings('error_on_request');
          toast.error(message);
        }
        toggleLoading(false);
      } catch (err) {
        toast.error(Strings('general_error'));
        toggleLoading(false);
      }
      toggle();
    }

  }, [authenticated, remixPars, toggleLoading, refresh, toggle]);

  const downloadMedia = useCallback((media) => {
    let urlMedia;

    if (media && remixPars) {
      const remix = remixPars;

      const BASE_DATE = '20190605000000'; // June 05 2019
      const remixDate = remix.rmdate;

      if (remixDate < BASE_DATE) {
        // Old remixes
        if (media.etype === 2 && media.url) {
          urlMedia = `${PZ_VIDEO_DOWNLOAD_URL}/${media.eid}.mp4`;
        } else if (media.etype === 1 && media.eown && media.eid) {
          urlMedia = PZ_IMAGE_DOWNLOAD_LOW_QUALITY_URL;
          urlMedia = urlMedia.replace('{username}', media.eown);
          urlMedia = urlMedia.replace('{id}', media.eid);
        }
      } else {
        if (media.etype === 2 && media.eid) {
          urlMedia = `${PZ_VIDEO_DOWNLOAD_URL}/${media.eid}.mp4`;
        } else if (media.etype === 1 && media.eid) {
          urlMedia = `${PZ_IMAGE_DOWNLOAD_URL}/${media.eid}.jpg`;
        }
      }
    }

    if (urlMedia) {
      const _t = (media.emdate) ? media.emdate : Date.now();
      const url = `${urlMedia}?_t=${_t}`;

      const link = document.createElement('a');
      link.href = url;
      link.download = '';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }, [remixPars]);

  const setAsCover = useCallback(async (eid) => {
    const remix = remixPars;

    if (eid && remix && remix.rid) {
      toggleLoading(true);

      try {
        const args = { un: authenticated.un, al: authenticated.al, rid: remix.rid, eid };
        const response = await PSO.setRemixCover(args);
  
        if (response.result === 'success') {
          toast.success(Strings('success'));
        } else {
          const message = (response && response.error) ? response.error : Strings('error_on_request');
          toast.error(message);
        }
      } catch (err) {
        toast.error(Strings('request_error_2'));
      }

      toggleLoading(false);
    }
  }, [authenticated, remixPars, toggleLoading]);

  return (
    <Modal isOpen={open} toggle={toggle} size='md'>
      <ModalBody>
        {photo && (
          <Row>
            <Col sm={12} className="text-center position-relative media-manage-modal-container">
              {parseInt(photo.etype) === 1 && (
                <img
                  className="img-fluid"
                  alt={photo.eid}
                  src={IMAGE_SRC.replace('{id}', photo.eid)}
                />
              )}
              {parseInt(photo.etype) === 2 && (
                <video
                  playsInline
                  controls
                  controlsList='nodownload noplaybackrate noremoteplayback'
                  disablePictureInPicture
                >
                  <source src={VIDEO_SRC.replace('{id}', photo.eid)} />
                </video>
              )}
              {showPrevious && (
                <Button size='sm' className='arrow previous' onClick={() => { if (previous) { previous(); } }}>
                  <IoArrowBack />
                </Button>
              )}
              {showNext && (
                <Button size='sm' className='arrow next' onClick={() => { if (next) { next(); } }}>
                  <IoArrowForward />
                </Button>
              )}
            </Col>
            <Col sm={12} className='text-center'>
              <a href={`${REMIX_URL}?u=${photo.eown}`} target='_blank' rel='noreferrer noopener'>
                @{photo.eown}
              </a>
            </Col>

            <Col className='mt-2 d-flex justify-content-center gap-1'>
              <Button
                size='sm'
                color='secondary'
                outline
                onClick={() => setAsCover(photo.eid)}
              >
                {Strings('set_as_cover')}
              </Button>

              <Button
                size='sm'
                color='primary'
                outline
                onClick={() => downloadMedia(photo)}
                title={Strings('download')}
              >
                <FaDownload />
              </Button>

              {photo.to_authorize === 0 && (
                <Button
                  size='sm'
                  color="danger"
                  outline
                  onClick={() => disapproveElement(photo.eid, photo.etype)}
                  title={Strings('remove')}
                >
                  <FaRegTrashCan />
                </Button>
              )}
              {photo.to_authorize === 1 && (
                <Button
                  size='sm'
                  color="success"
                  outline
                  onClick={() => approveElement(photo.eid, photo.etype)}
                >
                  {Strings('approve')}
                </Button>
              )}
            </Col>

          </Row>
        )}
      </ModalBody>
    </Modal>
  );
}
